import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { ClientErrorCodes, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { FileDownloadService, ModalService, QueueDefinitionService, QueueItemService, SessionsService, } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import * as moment from 'moment';
import { filter, map, switchMap, takeUntil, tap, } from 'rxjs/operators';
import { TransactionDetailsModalComponent, TransactionReviewerModalComponent, TransactionUpsertModalComponent, } from '../../modals';
import { DEFAULT_EXPAND, DEFAULT_REVIEW_STATUS, excludedReviewStatus, PRIORITY_TYPE_OPTIONS, PROCESSING_EXCEPTION_TYPE_OPTIONS, queueItemToIdentifier, REVIEW_STATUS_OPTIONS, transactionStatusFor, } from './transaction-items.constants';
var ɵ0 = urlStateHandler;
var TransactionsItemsGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionsItemsGridComponent, _super);
    function TransactionsItemsGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = {
            review: REVIEW_STATUS_OPTIONS,
            priority: PRIORITY_TYPE_OPTIONS,
            processingException: PROCESSING_EXCEPTION_TYPE_OPTIONS,
        };
        _this.isQueuesViewGranted$ = _this._appState.user.permissions.isGranted('Queues.View');
        _this.isRobotsViewGranted$ = _this._appState.user.permissions.isGranted('Robots.View');
        _this.isTransactionsEditGranted$ = _this._appState.user.permissions.isGranted('Transactions.Edit');
        _this.reviewerSuggest = _this._service.suggestReviewers;
        _this.robotSuggest = _this._injector.get(SessionsService).suggest;
        _this._queueDefinition = _this._injector.get(QueueDefinitionService);
        _this._queueItemService = _this._service;
        _this._modalService = _this._injector.get(ModalService);
        _this._downloadService = _this._injector.get(FileDownloadService);
        _this._handleFailedItems = function (response) {
            if (response.success) {
                _this._grid.selectionManager.clear();
                return;
            }
            _this._snack.error(response.message + " (#" + ClientErrorCodes.TransactionItemsFailed + ")");
            _this._grid.selectionManager.selected.forEach(function (queueItem) {
                var isFailed = response.failedItems.includes(queueItem.id);
                if (!isFailed) {
                    _this._grid.selectionManager.deselect(queueItem);
                }
            });
        };
        _this._coerceItemSelection = function (item) { return item != null ?
            [(item)] :
            _this._grid.selectionManager.selected; };
        return _this;
    }
    Object.defineProperty(TransactionsItemsGridComponent.prototype, "queueId", {
        get: function () {
            return this._queueId;
        },
        set: function (id) {
            if (id != null) {
                this._filters$.next(this._filters$.value.concat([
                    {
                        value: Number(id),
                        method: 'eq',
                        property: 'queueDefinitionId',
                    },
                ]));
                this._queueId = id;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionsItemsGridComponent.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (id) {
            if (id != null && this._userId !== id) {
                this._userId = id;
                this._filters$.next(this._filters$.value.concat([
                    {
                        method: 'eq',
                        value: id,
                        property: 'reviewerUser.id',
                    },
                ]));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionsItemsGridComponent.prototype, "isReviewMode", {
        get: function () {
            return !!this._isReviewMode;
        },
        set: function (value) {
            this._isReviewMode = value;
            this._filters$.next(this._filters$.value.concat(excludedReviewStatus(this.isReviewMode)));
            this._expand$.next(value ? DEFAULT_EXPAND.concat(['QueueDefinition']) : DEFAULT_EXPAND);
            this.transactionStatus = transactionStatusFor(this.isReviewMode);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionsItemsGridComponent.prototype, "reviewFilter", {
        get: function () {
            return this.isReviewMode ? REVIEW_STATUS_OPTIONS.find(function (s) { return s.label === DEFAULT_REVIEW_STATUS; }) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionsItemsGridComponent.prototype, "queueSuggest", {
        get: function () { return this._queueDefinition.suggest; },
        enumerable: true,
        configurable: true
    });
    TransactionsItemsGridComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reportUrl$ = this._activeQuery$.pipe(map(function (qo) { return _this._queueDefinition.getReportsUrl(_this.queueId, qo); }));
    };
    TransactionsItemsGridComponent.prototype.showDetails = function (entry) {
        var clone = cloneDeep(entry);
        this._modalService.openModal(TransactionDetailsModalComponent, clone, { size: 'lg' });
    };
    TransactionsItemsGridComponent.prototype.edit = function (entry, isDuplicate) {
        var _this = this;
        if (isDuplicate === void 0) { isDuplicate = false; }
        var clone = cloneDeep(entry);
        this._queueDefinition.getQueueNameAndSlaById(entry.queueDefinitionId)
            .pipe(switchMap(function (_a) {
            var name = _a.name, slaMinutes = _a.slaMinutes;
            var queueItemDto = {
                id: clone.id,
                name: name,
                priority: clone.priority,
                progress: clone.progress,
                specificContent: clone.specificContent,
                deferDate: clone.deferDate ? moment(clone.deferDate) : undefined,
                dueDate: clone.dueDate ? moment(clone.dueDate) : undefined,
                reference: clone.reference,
                slaEnabled: slaMinutes > 0,
            };
            return _this._modalService
                .openModal(TransactionUpsertModalComponent, queueItemDto, { isDuplicate: isDuplicate })
                .afterClosedResult();
        }), takeUntil(this._destroyed$)).subscribe(function () {
            _this._refresh$.next();
        });
    };
    TransactionsItemsGridComponent.prototype.clone = function (entry) {
        this.edit(entry, true);
    };
    TransactionsItemsGridComponent.prototype.setReviewer = function (item) {
        var _this = this;
        var queueItemIdentifiers = this._coerceItemSelection(item).map(queueItemToIdentifier);
        this._modalService
            .openModal(TransactionReviewerModalComponent, queueItemIdentifiers, {
            size: 'sm',
            overflow: true,
        })
            .afterClosedResult()
            .pipe(filter(function (res) { return res.type === 0 /* Generic */; }), map(function (res) { return res.data; }), tap(function () { return _this._refresh$.next(); }))
            .subscribe(this._handleFailedItems);
    };
    TransactionsItemsGridComponent.prototype.setState = function (state, item) {
        var _this = this;
        var queueItemIdentifiers = this._coerceItemSelection(item).map(queueItemToIdentifier);
        this.loading$.next(true);
        this._queueItemService
            .changeItemReviewStatus(queueItemIdentifiers, state)
            .pipe(tap(function () { return _this._refresh$.next(); }))
            .subscribe(this._handleFailedItems);
    };
    TransactionsItemsGridComponent.prototype.isSelectable = function (item) {
        return item.status !== 'InProgress';
    };
    TransactionsItemsGridComponent.prototype.canPerformActionIf = function (status, item) {
        // All selected items must respect the following:
        // count(selected) is not 0
        // 1. status is in (Failed, Abandoned)
        // 2. review status is in (None, InReview)
        // If there is at least one item for which one of the rules does not apply
        // We cannot mark the group (return false)
        var statuses = ['Failed', 'Abandoned'];
        var reviewStatuses = ['None', status];
        var selectedItems = this._coerceItemSelection(item);
        return selectedItems
            .filter(function (qi) { return !(statuses.indexOf(qi.status) > -1
            && qi.reviewStatus && reviewStatuses.indexOf(qi.reviewStatus) > -1); })
            .length === 0;
    };
    TransactionsItemsGridComponent.prototype.canSetReviewer = function (item) {
        var statuses = ['Failed', 'Abandoned'];
        var reviewStatuses = ['None'];
        var selectedItems = this._coerceItemSelection(item);
        return selectedItems
            .filter(function (qi) { return !(statuses.indexOf(qi.status) > -1
            && qi.reviewStatus && reviewStatuses.indexOf(qi.reviewStatus) > -1); })
            .length === 0;
    };
    TransactionsItemsGridComponent.prototype.canDelete = function (item) {
        // All selected items must respect the following:
        // count(selected) is not 0
        // 1. status is not in (InProgress, Deleted)
        // If there is at least one item for which this rule does not apply
        // We cannot mark the group (return false)
        var notPermittedStatuses = ['InProgress', 'Deleted'];
        var selectedItems = this._coerceItemSelection(item);
        return selectedItems
            .filter(function (qi) { return notPermittedStatuses.indexOf(qi.status) > -1; }).length === 0;
    };
    TransactionsItemsGridComponent.prototype.removeQueueItems = function (item) {
        var _this = this;
        var queueItemIdentifiers = this._coerceItemSelection(item).map(queueItemToIdentifier);
        this._modalService.onConfirm(null, function () {
            _this.loading$.next(true);
            _this._queueItemService
                .deleteBulk(queueItemIdentifiers)
                .pipe(tap(function () { return _this._refresh$.next(); }))
                .subscribe(_this._handleFailedItems);
        }, function () { }, this._translate.instant('grid_action_delete_message'));
    };
    TransactionsItemsGridComponent.prototype.canEdit = function (item) {
        return ['New', 'Failed', 'Abandoned'].includes(item.status);
    };
    TransactionsItemsGridComponent.prototype.canClone = function (item) {
        return ['New', 'Failed', 'Successful', 'Abandoned'].includes(item.status);
    };
    TransactionsItemsGridComponent.prototype.downloadReport = function (event, reportUrl) {
        event.preventDefault();
        this._downloadService.download(reportUrl);
    };
    TransactionsItemsGridComponent.prototype._ouDependentFilters = function () {
        return ['queueDefinition.id', 'robot.id'];
    };
    return TransactionsItemsGridComponent;
}(ODataGridComponent));
export { TransactionsItemsGridComponent };
export { ɵ0 };
